import { useMemo } from 'react';

import { keyOf } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn } from '@Components/Grid/utils/column';

import ActionFormatter from './ActionFormatter';
import ColorizeNumberFormatter from './ColorizeNumberFormatter';
import DateFormatter from './DateFormatter';
import DetailsEntity from './DetailsEntity';
import EntityLinkFormatter from './EntityLinkFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumn('bucket_id', 'Bucket ID', info => info.getValue() || '--', { size: 100 }),
    column.accessor('ref_date', {
      header: 'Date',
      cell: info => <DateFormatter info={info} />,
    }),
    column.accessor('', {
      header: 'Action',
      cell: info => <ActionFormatter info={info} />,
      size: 100,
    }),
    column.accessor('publisher_name', {
      header: 'Publisher',
      cell: info => <EntityLinkFormatter entity='publisher' info={info} />,
    }),
    column.accessor('allocation_name', {
      header: 'Allocation',
      cell: info => <EntityLinkFormatter entity='allocation' info={info} />,
    }),
    defaultColumn('subid', 'SubID', undefined, { size: 100 }),
    column.accessor('transaction_value', {
      header: 'Transaction Value',
      cell: info => <ColorizeNumberFormatter info={info} />,
      size: 100,
    }),
    column.accessor('bucket_value', {
      header: 'Previous Balance',
      cell: info => <ColorizeNumberFormatter info={info} />,
      size: 100,
    }),
    defaultActionsColumn(detailsAction),
  ], [])
}

function detailsAction(info) {
  return <DetailsEntity key={keyOf(info, 'details')} info={info} />
}
